import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  async sync() {
    const res = await fetch("/vehicles/sync", {
      method: "POST",
      headers: { "X-CSRF-Token": this._csrf() }
    })
    if (!res.ok) {
      console.error(await res.text())
      alert("Synchronisation Tesla échouée.")
    } else {
      location.reload()
    }
  }
  _csrf(){ return document.querySelector('meta[name="csrf-token"]').content }
}
